export const version = 'kunde-v1.20.0-SNAPSHOT-9b34cfa864dae97cf83c338460bc58e5f343a154';